import * as ActionTypes from './actionTypes';
import { createApiClient } from '../api.client';
import { startLoading, finishLoading } from '../actions';
import { clearAllLevel, enabledNextLevel } from "../SequenceHandler";
import { CLAPPLY_GENERIC_ERRORS, DOCUPLOAD_GENERIC_ERRORS, IDV_FLAG, INAVLID_MESSAGES } from "../constants";
import { getBarcaoformData } from "./loanApplicationActions";
import { fireDirectCallRule } from './../analytics/adobe/taggingHelper';
import { getIntervalConfig } from "../utils/is.after";
const INTERVAL_CONFIG=getIntervalConfig();
const COUNT_INITIAL_VALUE = 1;
export const personalizedQuoteReceived = (crossSellPersonalizedQuote) => ({
  type: ActionTypes.PERSONALIZED_QUOTE_RECEIVED,
  crossSellPersonalizedQuote: crossSellPersonalizedQuote
});

export const updateAprs = (aprs) => ({
  type: ActionTypes.UPDATE_APRS,
  aprs: aprs
});

export const setIdvChallengeData = (data) => ({
  type: ActionTypes.DECISION_API_RESPONSE,
  payload: data
});

export const setGenerateOtpData = (data) => ({
  type: ActionTypes.GENERATE_OTP_DATA,
  payload: data
});

export const setBankAccountInfo = (data) => ({
  type: ActionTypes.SET_BANK_ACCOUNT_INFO,
  payload: data
});

export const setVeridQuestions = (data) => ({
  type: ActionTypes.SET_VERID_QUESTIONS,
  payload: data
});

export const setKBVQuestions = (data) => ({
  type: ActionTypes.SET_KBV_QUESTIONS,
  payload: data
});

export const setFollowUpQuestions = (data) => ({
  type: ActionTypes.SET_FOLLOWUP_QUESTIONS,
  payload: data
});

export const idvDisableContinueBtn = (data) => ({
  type: ActionTypes.SET_IDV_BTN_DISABLE,
  payload: data
});



export const updateOffers = (userRequestedLoanAmount) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      const updateOffersResponse = await apiClient.postForm('/clapply/action/customizeOffer', userRequestedLoanAmount, 'calculateMonthlyPayment');
      dispatch(updateAprs(updateOffersResponse));
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    }
  };
};

export const savePersonalizedQuote = (crossSellPersonalizedQuote, fordward) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      const formData = bindSavePersonalizedParameter(crossSellPersonalizedQuote);
      const response = await apiClient.postForm('/clapply/action/customizeOffer/savePersonalizedQuote', formData );
      if(response.statusCode === 200){
        enabledNextLevel(2);
        dispatch({
          type: ActionTypes.ACCOUNT_INFO,
          payload: { type: ActionTypes.EXTERNAL_BANK_ACCOUNT_LIST_RESET }
        });

        if(response.data){
          if(response.data.loan){
            dispatch(personalizedQuoteReceived(response.data.loan));
          }
          if(response.data.account){
            dispatch({
              type: ActionTypes.UPDATE_BANK_ACCOUNT_LIST,
              account: response.data.account
            });
          }
        }
        gotoNextPage(fordward);
      }else{
        showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
      }
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};
const bindSavePersonalizedParameter=(data)=>{
  let formData={
    "crossSellPersonalizedQuoteRequest.monthlyPayment": data.monthlyPayment,
    "crossSellPersonalizedQuoteRequest.termInMonths": data.termInMonths,
    "crossSellPersonalizedQuoteRequest.apr": data.apr,
    "crossSellPersonalizedQuoteRequest.loanAmount": data.loanAmount,
    "crossSellPersonalizedQuoteRequest.costOfLoan": data.costOfLoan,
    "crossSellPersonalizedQuoteRequest.paymentDueDate": data.paymentDueDate,
    "stateChanged": true
  };
  return formData;
};
export const addExternalBankAccount = (bankAccount, externalParam, callbackFunction) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      const formData={};
      formData["externalAccountDetailsRequest"]=externalParam;
      formData["externalAccountDetailsRequest.externalAccountDetails"]=bankAccount;
      const addBankAccountResponse = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'addBankDetails');
      if(addBankAccountResponse.statusCode === 200){
        showAlert(true, { heading: "Your bank account has been added.", desc: addBankAccountResponse.message, alertType: "success" }, dispatch, true);
        dispatch({
          type: ActionTypes.ACCOUNT_INFO,
          payload: { type: ActionTypes.EXTERNAL_BANK_ACCOUNT_LIST, bankAccountDetails: addBankAccountResponse.data.externalAccountDetails }
        });
        callbackFunction({ statusCode: 200 });
      } else if(addBankAccountResponse.statusCode === 400|| addBankAccountResponse.statusCode === 401){
        if(!addBankAccountResponse.applicationStatus) {
          showAlert(true, { heading: "Error", desc: "Something went wrong!", alertType: "danger" }, dispatch);
        }
        callbackFunction(addBankAccountResponse);
      } else{
        showAlert(true, { heading: "Error", desc: addBankAccountResponse.message, alertType: "danger" }, dispatch);
      }
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};
export const switchTabs = (info) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.ACCOUNT_INFO,
      payload: { type: ActionTypes.COMPONENT_SWITCH_INFO, tabs: info }
    });
  };
};

export const getFraudChallenge=async (dispatch, bankAccount, fordward, response, callbackFunction)=>{
  let bankInfo={
    bankAccount: bankAccount,
    fordward: fordward
  };
  dispatch(setBankAccountInfo(bankInfo));
  if(response.statusCode === 200){
    const fraudApiResponse = await fraudValidation();
    let status = fraudApiResponse.status;
    let challengeType = fraudApiResponse.challengeType;
    let verificationContextsId = fraudApiResponse.verificationContextsId;
    status = (status?status:"").toLowerCase();

    //FRAUD CALL
    if(status == "approved" || status == "skip"){
      //APPROVED
      dispatch(idvDisableContinueBtn(status));
      await saveBankAccountDetails(bankAccount, fordward, dispatch);
    } else if(status === "pended"){
      let authLock=fraudApiResponse.authLock;
      if(authLock){
        //AUTHLOCK
        await saveBankAccountDetails(bankAccount, fordward, dispatch, true);
      } else {
        //UPDATE_POWER_CURVE
        dispatch(idvDisableContinueBtn(status));
        await saveBankAccountDetails(bankAccount, fordward, dispatch);
      }
    } else if(status === "challenged"){
      dispatch(idvDisableContinueBtn(status));
      dispatch(setIdvChallengeData(fraudApiResponse));
      if(challengeType==='VERID'){
        //KBV HANDLING
        let kbvType = fraudApiResponse.veridKbvResponses[1]&&fraudApiResponse.veridKbvResponses[1].knowledgeQuestionLevel;
        let veridQuestionsResponse = await getVeridQuestion(verificationContextsId, kbvType, bankInfo, dispatch);
        if(veridQuestionsResponse.statusCode==500){
          showAlert(true, { heading: "Error", desc: fraudApiResponse.message, alertType: "danger" }, dispatch);
        } else {
          dispatch(setVeridQuestions(veridQuestionsResponse));
          fordward.nextPage="/clapply/action/customizeOffer/securityCheck";
          gotoNextPage(fordward);
        }
      } else {
        fordward.nextPage="/clapply/action/customizeOffer/securityCheck";
        gotoNextPage(fordward);
      }

    } else if(status == "pended_retry" && callbackFunction){
      showAlert(true, { heading: "Something went wrong", desc: INAVLID_MESSAGES.ACCOUNT.ACC_INVALID_ALERT, alertType: "danger" }, dispatch, true);
      callbackFunction(true);
    } else{
      showAlert(true, { heading: "Error", desc: fraudApiResponse.message, alertType: "danger" }, dispatch);
    }
  } else{
    showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
  }
};

export const saveBankAccountDetails=async (bankAccount, fordward, dispatch, isAuthLock, bankInfo)=>{
  const response = await saveBankAccount();
  if(response.statusCode === 200){
    if(isAuthLock){
      let resp = await submitFullApp(bankAccount, fordward, dispatch, isAuthLock);
      if(resp.authLockNavigate) {
        fordward.nextPage="/clapply/action/customizeOffer/authLock";
        gotoNextPage(fordward);
      } else {
        showAlert(true, { heading: "Error", desc: "Something went wrong", alertType: "danger" }, dispatch);
      }
    }else{
      await submitFullApp(bankAccount, fordward, dispatch, isAuthLock);
    }
  }else{
    showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
  }
};

export const saveBankAccount = async () => {
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.postForm('/clapply/action/customizeOffer', null, 'saveBankAccountDetails');
    return response;
  }catch (e) {
    return { statusCode: 400, message: "Something is wrong" };
  }
};
export const validateRoutingNumber = (bankAccount, fordward, callbackFunction) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      const formData=bindParameter(bankAccount);
      const response = await apiClient.postForm('/clapply/action/customizeOffer/validateRoutingNumber', formData );
      if(response.statusCode === 200){
        await getFraudChallenge(dispatch, bankAccount, fordward, response, callbackFunction);
      }else if(response.statusCode===1001){
        showAlert(true, { heading: "Something went wrong", desc: response.message, alertType: "danger" }, dispatch);
      }else if(response.statusCode === 417 && response.message === "INVALID_ROUTING_NUMBER"){
        showAlert(true, { heading: "Something went wrong", desc: INAVLID_MESSAGES.ACCOUNT.ACC_INVALID_ALERT, alertType: "danger" }, dispatch, true);
        callbackFunction(false, response);
      }else{
        showAlert(true, { heading: "Something went wrong", desc: response.message, alertType: "danger" }, dispatch);
      }

    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

export const submitFullApp =async (bankAccount, fordward, dispatch, isAuthLock) => {
  const apiClient = createApiClient();
  const submitFullAppResponse = await apiClient.postForm('/clapply/action/customizeOffer', null, 'submitFullApp');
  if(submitFullAppResponse.statusCode === 200){
    const statusResponse = await getSubmitApplicationStatus(COUNT_INITIAL_VALUE);
    if(isAuthLock && statusResponse){
      return { authLockNavigate: true };
    } else {
      if(statusResponse.statusCode === 200){
        enabledNextLevel(3);
        dispatch(personalizedQuoteReceived(statusResponse.data));
        dispatch({
          type: ActionTypes.ACCOUNT_INFO_UPDATE,
          loanBankInfo: bankAccount
        });
        dispatch({
          type: ActionTypes.ACCOUNT_INFO,
          payload: { type: ActionTypes.EXTERNAL_BANK_ACCOUNT_LIST_RESET }
        });
        fordward.nextPage="/clapply/action/customizeOffer/bankDetailsConfirm";
        gotoNextPage(fordward);
      }else if(statusResponse.statusCode == 415){
        let status =statusResponse.applicationStatus;
        status = (status?status:"").toLowerCase();
        if(status === "declined"){
          fordward.nextPage="/clapply/action/customizeOffer/declineOffer";
          gotoNextPage(fordward);
        }else if(status === "pending"){
          location.href=statusResponse.data;
        }
      }else{
        showAlert(true, { heading: "Error", desc: statusResponse.message, alertType: "danger" }, dispatch);
      }
    }
  }else{
    if(isAuthLock){
      return { authLockNavigate: true };
    }
    showAlert(true, { heading: "Error", desc: submitFullAppResponse.message, alertType: "danger" }, dispatch);
  }
  return 0;
};

export const fraudValidation = async () => {
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.postForm('/clapply/action/customizeOffer', null, 'idvFraudValidation', null);
    return response;
  }catch (e) {
    return { statusCode: 400, message: "Something is wrong" };
  }
};

export const getSubmitApplicationStatus = async (limit) => {
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.postDelayAPI('/clapply/action/customizeOffer', { count: limit, maxCount: INTERVAL_CONFIG.PCO_105.COUNT }, 'fetchFullAppStatus', null, getDelayTime(limit, INTERVAL_CONFIG.PCO_105));
    let status =response.applicationStatus;
    status = (status?status:"").toLowerCase();
    if(status === "submitted" || status === "retry"){
      if(limit < INTERVAL_CONFIG.PCO_105.COUNT){
        return getSubmitApplicationStatus(limit+1);
      }
    }
  }catch (e) {
    return { statusCode: 400, message: "Something is wrong" };
  }
  return response;
};
export const storeTermsInSession = (terms, fordward) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      let formData = bindTermsParameter(terms);
      const response = await apiClient.postForm('/clapply/action/customizeOffer/saveTermsAndConditions', formData );
      if(response.statusCode === 200){
        enabledNextLevel(4);
        dispatch({
          type: ActionTypes.ACCOUNT_TERM_INFO_UPDATE,
          offerAcceptDetails: terms
        });
        gotoNextPage(fordward);
      }else{
        showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
      }
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: JSON.stringify(errors[0]), alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

export const saveAgreeAndSubmit = (sign, fordward) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      const response = await apiClient.postForm('/clapply/action/customizeOffer', { sign: sign }, 'submitEsign');
      if(response.statusCode === 200){
        const loanApplicationResponse = await getLoanApplicationStatus(COUNT_INITIAL_VALUE);
        enabledNextLevel(5);
        dispatch({
          type: ActionTypes.ACCOUNT_SIGN_INFO_UPDATE,
          sign: sign
        });
        dispatch({
          type: ActionTypes.ACCOUNT_TERM_CONDITION_UPDATE,
          isOfferAccepted: loanApplicationResponse.applicationStatus
        });
        gotoNextPage(fordward);
      }else{
        showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
      }
    } catch (errors){
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

export const getLoanApplicationStatus = async (limit) => {
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.postDelayAPI('/clapply/action/customizeOffer', { count: limit, maxCount: INTERVAL_CONFIG.INSPECT_OFFER.COUNT }, 'fetchAccountStatus', null, getDelayTime(limit, INTERVAL_CONFIG.INSPECT_OFFER));
    if(response.statusCode !== 200){
      if(limit < INTERVAL_CONFIG.INSPECT_OFFER.COUNT){
        return getLoanApplicationStatus(limit+1);
      }
    }
  }catch (e) {
    return { statusCode: 400, message: "Something is wrong" };
  }
  return response;
};

export const saveCustomerInformation = (custInfo, offerFinalDecision) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      const formData={ ...custInfo };
      formData.barcaoform = getBarcaoformData();
      dispatch(startLoading());
      const response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'submitCYR');
      if(response.statusCode === 200){
        if(response.applicationStatus !== null && response.applicationStatus !== "OPENED"){
          enabledNextLevel(1);
          offerFinalDecision(response.applicationStatus);
        } else{
          const fetchQuotesResponse = await fetchQuotesFromAPI(COUNT_INITIAL_VALUE);
          if(!isStatusCode(fetchQuotesResponse)){
            setFetchQuotes(fetchQuotesResponse, custInfo, offerFinalDecision, dispatch);
          }else{
            showAlert(true, { heading: "Error", desc: fetchQuotesResponse.message, alertType: "danger" }, dispatch);
          }
        }
      }else{
        showAlert(true, { heading: "Error", desc: response.message, alertType: "danger" }, dispatch);
      }
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

export const fetchActiveLoans = () => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    const res = await apiClient.postForm('/clapply/action/customizeOffer', null, 'fetchActiveLoans');
    console.log('**', res);
  };
};

export const fetchExternalAccounts = () => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    const res = await apiClient.postForm('/clapply/action/customizeOffer', null, 'fetchExternalAccounts');
    console.log('**', res);
  };
};

export const setFetchQuotes = (fetchQuotesResponse, custInfo, offerFinalDecision, dispatch) => {
  enabledNextLevel(1);
  if(fetchQuotesResponse.applicationStatus === "APPROVED"){
    dispatch({
      type: ActionTypes.CUSTOMER_INFORMATION,
      customerInformation: custInfo
    });
    dispatch({
      type: ActionTypes.UPDATE_OFFER_DETAILS,
      offerDetails: fetchQuotesResponse
    });
  }else{
    if(fetchQuotesResponse.applicationStatus !== "DECLINED"){
      showAlert(true, { heading: "Error", desc: fetchQuotesResponse.message, alertType: "danger" }, dispatch);
    }
  }
  offerFinalDecision(fetchQuotesResponse.applicationStatus);
};
export const fetchQuotesFromAPI = async (limit) => {
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.postDelayAPI('/clapply/action/customizeOffer', { count: limit, maxCount: INTERVAL_CONFIG.FETCH_QUOTES.COUNT }, 'fetchCYRStatus', null, getDelayTime(limit, INTERVAL_CONFIG.FETCH_QUOTES));
    if(isStatusCode(response) && response.statusCode!=406 ){
      if(limit < INTERVAL_CONFIG.FETCH_QUOTES.COUNT){
        return fetchQuotesFromAPI(limit+1);
      }
    }
  }catch (e) {
    return { statusCode: 400, message: "Something is wrong" };
  }
  return response;
};



export const uploadRequiredDocs = (flies, isComplete, fordward, logoutUrl, skipUploadDoc) => {
  return async (dispatch) => {
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      const uploadFileResponse = await uploadFiles(flies, skipUploadDoc);
      if(uploadFileResponse.statusCode === 200){
        if(isComplete){
          const completeUploadResponse = await completeUpload();
          if(completeUploadResponse.statusCode===200){
            dispatch({
              type: ActionTypes.COMPLETE_UPLOAD_DOCUMENT_STATUS,
              documentUploaded: true,
              status: completeUploadResponse.applicationStatus
            });
            gotoNextPage(fordward);
          }else{
            showAlert(true, { heading: "Error", desc: completeUploadResponse.message, alertType: "danger" }, dispatch, (completeUploadResponse.statusCode === 417));
          }
        }
      }else if(uploadFileResponse.statusCode === 417){
        showAlert(true, { heading: "Error", desc: uploadFileResponse.message, alertType: "danger" }, dispatch, (uploadFileResponse.statusCode === 417));
      } else{
        let isError = DOCUPLOAD_GENERIC_ERRORS.indexOf(uploadFileResponse.message);
        showAlert(true, { heading: "Error", desc: uploadFileResponse.message, alertType: "danger" }, dispatch, (isError !== -1));
      }
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

const uploadFiles=async (files, skipUploadDoc)=>{
  const apiClient = createApiClient();
  let response = null;
  try {
    for(let index in files){
      const formFiles = new FormData();
      let cat = files[index];
      for(let i in cat.files){
        formFiles.append(`uploadDocuments[${i}]`, cat.files[i]);
      }
      formFiles.append(`documentCategory`, cat.cat);
      response = await apiClient.uploadDocuments('/clapply/action/customizePendingOffer/uploadRequiredDocs', formFiles);
      if(response.statusCode !== 200){
        return response;
      }
    }
  }catch (e) {
    throw e;
  }
  return response;
};

const completeUpload=async ()=>{
  const apiClient = createApiClient();
  let response = null;
  try {
    response = await apiClient.uploadDocuments('/clapply/action/customizePendingOffer/completeUpload');
  }catch (e) {
    throw e;
  }
  return response;
};



const bindTermsParameter=(data)=>{
  let formData={
    "bankDetailsConfirmationRequest.electronicConsent": data.electronicConsent,
    "bankDetailsConfirmationRequest.legalTermsAndCondition": data.legalTermsAndCondition,
    "bankDetailsConfirmationRequest.privacyPolicy": data.privacyPolicy
  };
  return formData;
};
const bindParameter=(data)=>{
  let formData={ "externalAccountDetailsRequest.autoPayEnrollEnabled": data.isAutoPayEnrollEnabled,
    "externalAccountDetailsRequest.authorizationConsent": data.authorizationConsent,
    "stateChanged": data.isStateChanged };
  formData["externalAccountDetailsRequest.depositAccountDetails"] = getProperty("", data.depositAccountDetails, {});
  formData["externalAccountDetailsRequest.repaymentAccountDetails"] = getProperty("", data.repaymentAccountDetails, {});
  return formData;
};

const getProperty=(key, data, formData)=>{
  formData[`${key}externalAccountType`]=data.externalAccountType;
  formData[`${key}nickname`]=data.nickname;
  formData[`${key}accountNumber`]=data.accountNumber;
  formData[`${key}confirmAccountNumber`]=data.confirmAccountNumber || data.accountNumber;
  formData[`${key}routingNumber`]=data.routingNumber;
  formData[`${key}currency`]=data.currency || "";
  formData[`${key}amount`]=data.amount || 0;
  formData[`${key}accountAddedInSession`]=data.accountAddedInSession || false;
  return formData;
};
const toggleSpinner =(toggle, dispatch)=>{
  dispatch({
    type: ActionTypes.SPINNER_TOGGLE,
    spinnerToggle: toggle
  });
};
export const showAlert =(show, message, dispatch, skip)=>{
  if(!skip){
    message.heading=CLAPPLY_GENERIC_ERRORS.title;
    message.desc=CLAPPLY_GENERIC_ERRORS.description;
  }
  dispatch({
    type: ActionTypes.SHOW_COMMON_ALERT,
    showAlert: { isError: show, message: { ...message } }
  });
};

const gotoNextPage =(fordward)=>{
  fordward.mover.push(fordward.nextPage);
};

export const closeAlert = (info) => {
  return async (dispatch) => {
    showAlert(false, {}, dispatch);
  };
};
export const redirectToAnotherApplication = (url, isBack) => {
  return async (dispatch) => {
    try {
      dispatch(startLoading());
      const apiClient = createApiClient();
      await apiClient.postForm('/clapply/action/customizeOffer', null, 'logOff');
    } catch (errors) {
      //showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    }finally {
      dispatch(finishLoading());
      if(isBack){
        window.history.back();
      }else{
        clearAllLevel();
        if(url){
          location.replace(url);
        }else{
          const host = `${location.protocol}//${location.host}/clapply/action/customizeOffer/sessionClose`;
          location.replace(host);
        }
      }
    }
  };
};

export const restrictBrowserBackProcess = () => {
  return (dispatch) => {
    try {
      const apiClient = createApiClient();
      apiClient.postForm('/clapply/action/customizeOffer/restrictBrowser' );
      dispatch({
        type: ActionTypes.LOCKED_BROWSER_BACK,
        lockedBrowserBack: true
      });
    } catch (errors) {
      //showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    }
  };
};

const isStatusCode =(response)=>"statusCode" in response;

//IDV ACTIONS

export const isAuthLock=(status, code)=>{
  if(status===423){
    return (code==='AUTH_LOCK') || (code ==='EX_HR_LOCKED') || (code==='LOCKED');
  } else if (status=== 422){
    return (code === 'VERID_EXPIRED') || (code==='NO_GENERATION_ATTEMPTS_REMAINING') || (code==='VERIFICATION_CONTEXT_EXPIRED');
  } else {
    let res =false;
    return res;
  }
};

export const checkOTPExpired=(status, code, attemptsCheck)=>status===410 && code==='ONE_TIME_PASSCODE_EXPIRED' && !attemptsCheck;
export const isKbvFlow=(status, code)=>(status===422 && code==='USER_NOT_FOUND')||(status===423 && code==='VERID_LOCKED');

export const getDecisionApi=(forward)=>{
  const apiClient = createApiClient();
  return async (dispatch) => {
    showAlert(false, {}, dispatch);
    dispatch(startLoading());
    try {
      const fraudApiResponse = await apiClient.postForm('/clapply/action/customizeOffer', null, 'getStepUpDecision');
      let status = fraudApiResponse.status;
      let challengeType = fraudApiResponse.challengeType;
      let verificationContextsId = fraudApiResponse.verificationContextsId;

      status = (status?status:"").toLowerCase();
      dispatch(setIdvChallengeData(fraudApiResponse));

      let bankAccount= {
        depositAccountDetails: fraudApiResponse.depositAccountDetails,
        repaymentAccountDetails: fraudApiResponse.repaymentAccountDetails,
        isAutoPayEnrollEnabled: fraudApiResponse.isAutoPayEnrollEnabled
      };
      let bankInfo={
        bankAccount: bankAccount,
        fordward: forward
      };
      dispatch(setBankAccountInfo(bankInfo));
      //FRAUD CALL
      if(status === "approved" || status === "skip"){
        await saveBankAccountDetails(bankAccount, forward, dispatch);
      } else if(status === "challenged"){
        if(challengeType==='VERID'){
          let veridQuestionsResponse = await apiClient.postForm('/clapply/action/customizeOffer', null, 'getVeridSessionResponse');
          let checkVeridEmpty=Object.keys(veridQuestionsResponse).length===0;
          if(veridQuestionsResponse.statusCode==500){
            showAlert(true, { heading: "Error", desc: fraudApiResponse.message, alertType: "danger" }, dispatch);
          } else if(checkVeridEmpty){
            let kbvResponse = await apiClient.postForm('/clapply/action/customizeOffer', null, 'getKbvSessionResponse');
            kbvResponse.isBankType=true;
            dispatch(setVeridQuestions(kbvResponse));
          } else {
            dispatch(setVeridQuestions(veridQuestionsResponse));
          }
        }
      }else{
        showAlert(true, { heading: "Error", desc: fraudApiResponse.message, alertType: "danger" }, dispatch);
      }

    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

//GENERATE OTP ACTION
export const generateOtp= (communicationId, verificationId, bankInfo) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    let formData={
      "generateOtpRequest": {
        "communicationMethodId": communicationId,
        "verificationContextId": verificationId
      }
    };
    showAlert(false, {}, dispatch);
    dispatch(startLoading());
    let response = null;
    try {
      response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'idvGenerateOtp');
      let errorCode = null;
      if(response.errors && response.errors.errors && response.errors.errors.length > 0){
        errorCode = response.errors.errors[0].code;
      }
      if(errorCode&&response.statusCode&&isAuthLock(response.statusCode, errorCode)){
        let customResponse={ statusCode: 200, message: '' };
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else if(response.statusCode && response.statusCode == 500) {
        showAlert(true, { heading: "Error", desc: 'Something went wrong', alertType: "danger" }, dispatch);
      } else {
        dispatch(setGenerateOtpData(JSON.parse(response)));
      }

    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

//VALIDATE OTP ACTION
export const validateOtp= (otpResponseId, otpValue, bankInfo, hasAttemptsLeft, challengeType) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    let response = null;
    let formData={
      "validateOtpRequest": {
        "otpResponseId": otpResponseId,
        "otp": otpValue
      }
    };
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'idvValidateOtp');
      let errorCode = null;
      if(response.errors && response.errors.errors && response.errors.errors.length > 0){
        errorCode = response.errors.errors[0].code;
      }
      let customResponse={ statusCode: 200, message: '' };
      if(errorCode && response.statusCode&&isAuthLock(response.statusCode, errorCode)){
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else if(errorCode && response.statusCode && checkOTPExpired(response.statusCode, errorCode, hasAttemptsLeft)) {
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else{
        let finalResponse=JSON.parse(response);
        await idvSubmitHandler(dispatch, bankInfo, finalResponse.data, "CROSS:SELL:OTP:SUCCESS", true, challengeType);
      }
    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

//SUBMIT RSA
export const submitRSA=(formData, bankInfo, challengeType) => {
  const apiClient = createApiClient();
  return async (dispatch) => {
    let response = null;
    try {
      showAlert(false, {}, dispatch);
      dispatch(startLoading());
      response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'idvSubmitAnswersRsa');
      let errorCode = null;
      if(response.errors && response.errors.errors && response.errors.errors.length > 0){
        errorCode = response.errors.errors[0].code;
      }
      if(errorCode&&response.statusCode&&isAuthLock(response.statusCode, errorCode)){
        let customResponse={ statusCode: 200, message: '' };
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else{
        let finalResponse=JSON.parse(response);
        await idvSubmitHandler(dispatch, bankInfo, finalResponse.data, "CROSS:SELL:RSA:SUCCESS", false, challengeType);
      }
    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

//GET VERID QUESTIONS
export const getVeridQuestion = async (verificationId, kbvType, bankInfo, dispatch) => {
  const apiClient = createApiClient();
  let response = null;
  let result=null;
  try {
    let formData={ verificationContextID: verificationId };
    response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'veridGetQuestions');
    if(response.statusCode){
      let errorCode = null;
      if(response.errors && response.errors.errors && response.errors.errors.length > 0){
        errorCode = response.errors.errors[0].code;
      }
      if(errorCode&&isAuthLock(response.statusCode, errorCode)){
        let customResponse={ statusCode: 200, message: '' };
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else if(isKbvFlow(response.statusCode, errorCode)){
        //GET KBV QUESTIONS
        let kbvResponse = await getKbvQuestions(verificationId, kbvType, bankInfo, dispatch);
        if(kbvResponse.statusCode){
          return { statusCode: 500, message: "Something is wrong" };
        } else {
          result = kbvResponse;
        }
      } else {
        return { statusCode: 500, message: "Something is wrong" };
      }
    } else {
      result= JSON.parse(response);
    }
    return result;
  } catch (e) {
    return { statusCode: 500, message: "Something is wrong" };
  }
};

export const getKbvQuestions=async(verificationId, kbvType, bankInfo, dispatch)=>{
  const apiClient = createApiClient();
  let kbvResponse = null;
  let result = null;
  try {
    let kbvFormData={
      kbVgetQuestionsRequest: {
        knowledgeQuestionLevel: kbvType,
        contextID: verificationId
      }
    };
    kbvResponse = await apiClient.postForm('/clapply/action/customizeOffer', kbvFormData, 'kbvGetQuestions');
    let errorCode = kbvResponse.errors&& kbvResponse.errors.errors[0].code;

    if(kbvResponse.statusCode&&isAuthLock(kbvResponse.statusCode, errorCode)){
      let customResponse={ statusCode: 200, message: '' };
      await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
    } else {
      let finalResponse= JSON.parse(kbvResponse);
      finalResponse.isBankType=true;
      result = finalResponse;
    }
    return result;
  }catch (e) {
    return { statusCode: 500, message: "Something is wrong" };
  }
};


//SUBMIT VERID QUESTIONS
export const submitVerid=(formData, bankInfo, kbvType, challengeType)=>{
  const apiClient = createApiClient();
  return async (dispatch) => {
    showAlert(false, {}, dispatch);
    dispatch(startLoading());
    let response = null;
    try {
      response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'veridVerifyAnswers');
      if(response.statusCode){
        let errorCode = null;
        if(response.errors && response.errors.errors && response.errors.errors.length > 0){
          errorCode = response.errors.errors[0].code;
        }
        if(errorCode&&response.statusCode&&isAuthLock(response.statusCode, errorCode)){
          let customResponse={ statusCode: 200, message: '' };
          await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
        } else if(isKbvFlow(response.statusCode, errorCode)){
          //GET KBV QUESTIONS
          let kbvResponse = await getKbvQuestions(formData.veridAnswersRequest.verificationContextId, kbvType, bankInfo, dispatch);
          if(kbvResponse.statusCode){
            showAlert(true, { heading: "Error", desc: 'Something went wrong!!', alertType: "danger" }, dispatch);
          } else {
            dispatch(setVeridQuestions(kbvResponse));
          }
        } else {
          showAlert(true, { heading: "Error", desc: 'Something went wrong!!', alertType: "danger" }, dispatch);
        }
      } else {
        let finalResponse=JSON.parse(response);
        await idvSubmitHandler(dispatch, bankInfo, finalResponse.data, "CROSS:SELL:VERID:SUCCESS", false, challengeType);
      }
    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

//SUBMIT KBV QUESTIONS
export const submitKbv=(formData, bankInfo, challengeType)=>{
  const apiClient = createApiClient();
  return async (dispatch) => {
    showAlert(false, {}, dispatch);
    dispatch(startLoading());
    let response = null;
    try {
      response = await apiClient.postForm('/clapply/action/customizeOffer', formData, 'kbvSubmitAnswers');
      let errorCode = null;
      if(response.errors && response.errors.errors && response.errors.errors.length > 0){
        errorCode = response.errors.errors[0].code;
      }
      if(errorCode&&response.statusCode&&isAuthLock(response.statusCode, errorCode)){
        let customResponse={ statusCode: 200, message: '' };
        await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
      } else{
        let finalResponse=JSON.parse(response);
        await idvSubmitHandler(dispatch, bankInfo, finalResponse.data, '', true, challengeType);
      }

    }catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    } finally {
      dispatch(finishLoading());
    }
  };
};

const idvSubmitHandler=async (dispatch, bankInfo, finalResponse, ruleName, isOtp, challengeType)=>{
  let finalStatus = finalResponse.attributes.status;
  let customResponse={ statusCode: 200, message: '' };
  if(finalStatus == 'SUCCESS'){
    ruleName?fireDirectCallRule(ruleName):null;
    await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
  } else if(finalStatus =='FOLLOW_UP_QUESTIONS'){
    let followUpQuestions = finalResponse.attributes.followUpQuestionAttributes.questions;
    dispatch(setFollowUpQuestions(followUpQuestions));
  } else if(finalStatus =='FAILURE'){
    let numberOfAttemptsRemaining = finalResponse.attributes.numberOfAttemptsRemaining;
    if(isOtp&&numberOfAttemptsRemaining===0){
      await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
    } else if(!isOtp){
      await getFraudChallenge(dispatch, bankInfo.bankAccount, bankInfo.fordward, customResponse);
    } else {
      showAlert(true, { heading: "Error", desc: "Something went wrong,Please try again !!", alertType: "danger" }, dispatch);
    }
  } else {
    showAlert(true, { heading: "Error", desc: "Something went wrong,Please try again !!", alertType: "danger" }, dispatch);
  }
};

const getDelayTime=(count, apiDelayConfig)=>{
  if(count === apiDelayConfig.COUNT || count === 0){
    return 0;
  }
  return apiDelayConfig.DELAY;
};


export const extendSession = () => {
  return (dispatch) => {
    try {
      const apiClient = createApiClient();
      apiClient.extendSessionXsell();
    } catch (errors) {
      showAlert(true, { heading: "Error", desc: errors[0], alertType: "danger" }, dispatch);
    }
  };
};
